import { render, staticRenderFns } from "./ContactBookPolicyForm.vue?vue&type=template&id=c3ff24b0"
import script from "./ContactBookPolicyForm.vue?vue&type=script&lang=js"
export * from "./ContactBookPolicyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports